export default __webpack_public_path__ + "static/media/CowPea.09f8f8b5.jpg";